import * as React from "react";
import styled from "styled-components";
const Box = styled.p `
	font-size: 12px;
	color: rgb(102, 102, 102);
	line-height: 16px;
	height: 16px;
	font-family: var(--fontMedium), var(--fontRegular);
`;
export const ShipTo24Hours = (props) => {
    const { text } = props;
    if (!text) {
        return null;
    }
    return React.createElement(Box, null, text);
};
